// Module
var code = `<h2 class="section-header">Interest fee board:</h2>

<div class="alert">
  Please note: In case of duplicated or missing rows default rate will be used for calculation
</div>
<div class="form-section">
  <div ng-if="\$ctrl.feeClass === 'CUSTOM' && \$ctrl.boardType === 'LOAN_BOARD' && \$ctrl.applyOn === 'LOAN_PAYMENT'">
    <div class="form-section-field-title">
      Configure different fee values for amortizations in defined term ranges
    </div>
    <input ng-model="\$ctrl.board.amortizationBoard"
           ng-change="\$ctrl.amortizationBoardChange()"
           type="checkbox" />
  </div>
  <div ng-if="\$ctrl.feeType === 'FIXED'">
    <div class="form-section-field-title">
      Default value
    </div>
    <cash ng-model="\$ctrl.board.defaultFixedAmount"
          ng-required="true"
          class="custom-fee-board__default-rate"
    >
    </cash>
  </div>
  <div ng-if="\$ctrl.feeType === 'PERCENTAGE'">
    <div class="form-section-field-title">
      Default rate
    </div>
    <glue-container ng-if="\$ctrl.feeType === 'PERCENTAGE'" append-percentage="true" class="custom-fee-board__default-rate">
      <input
        required
        type="number"
        min="0"
        max="1000"
        step="0.00001"
        ng-model="\$ctrl.board.defaultPercentageAmount">
    </glue-container>
  </div>

  <div>
    <div
      class="form-section-field-title">
      Add optional columns
    </div>

    <multiselect items="\$ctrl.optionalColumnNameOptions"
                 ng-model="\$ctrl.optionalColumnNames"
                 label-property="'label'"
                 value-property="'column'">
    </multiselect>
  </div>
</div>

<table
  class="table table--generate-row-ids"
>
  <thead>
  <tr>
    <th>No.</th>
    <th ng-repeat="column in \$ctrl.getVisibleProductColumns()">
      {{column.label}}
    </th>
    <th>Fee value</th>
    <th>Action</th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat="cell in \$ctrl.board.cells">
    <td></td>
    <td ng-repeat="column in \$ctrl.getVisibleProductColumns()">
      <select
        ng-if="column.column === 'rateTypeId'"
        required
        ng-model="cell.rateTypeId"
        ng-options="title.id as title.description for title in \$ctrl.dict.LOAN_RATE_TYPE">
      </select>
      <cash
        ng-if="column.column === 'minPrincipal'"
        ng-model="cell.minPrincipal"
        ng-required="true">
      </cash>
      <cash
        ng-if="column.column === 'maxPrincipal'"
        ng-change="\$ctrl.recalculateAvailableColumns()"
        ng-model="cell.maxPrincipal">
      </cash>
      <cash
        ng-if="column.column === 'minBalance'"
        ng-model="cell.minBalance"
        ng-required="true">
      </cash>
      <glue-container
        ng-if="column.column === 'minTerm'"
        append="'days'">
        <input class="input-days"
               required
               type="number"
               min="0"
               max="100000"
               step="1"
               ng-model="cell.minTerm">
      </glue-container>
      <glue-container append="'days'"
                      ng-if="column.column === 'maxTerm'">
        <input class="input-days"
               type="number"
               min="0"
               max="100000"
               step="1"
               ng-change="\$ctrl.recalculateAvailableColumns()"
               ng-model="cell.maxTerm">
      </glue-container>
      <cash
        ng-if="column.column === 'minTransactionAmount'"
        ng-model="cell.minTransactionAmount"
        ng-required="true">
      </cash>
      <cash
        ng-if="column.column === 'maxTransactionAmount'"
        ng-change="\$ctrl.recalculateAvailableColumns()"
        ng-model="cell.maxTransactionAmount">
      </cash>
      <selectize
        ng-if="column.column === 'paymentIntervals'"
        options="\$ctrl.intervalTypes"
        config="\$ctrl.paymentIntervalsConfig"
        class="nx-selectize"
        ng-change="\$ctrl.recalculateAvailableColumns()"
        ng-model="cell.paymentIntervals">
      </selectize>
      <select
        ng-if="column.column === 'collectionType'"
        ng-model="cell.collectionType"
        ng-options="c | prettyEnum for c in \$ctrl.collectByOptions"
        required>
      </select>
      <cash
        ng-if="column.column === 'minAmount'"
        ng-model="cell.minAmount"
        ng-disabled="\$ctrl.board.amortizationBoard"
        ng-required="!\$ctrl.board.amortizationBoard">
      </cash>
      <cash
        ng-if="column.column === 'maxAmount'"
        ng-change="\$ctrl.recalculateAvailableColumns()"
        ng-disabled="\$ctrl.board.amortizationBoard"
        ng-model="cell.maxAmount"
        min="cell.minAmount">
      </cash>
      <glue-container append="'years'"
                      ng-if="column.column === 'minCustomerAge'">
        <input class="input-days"
               type="number"
               min="0"
               max="100000"
               step="1"
               ng-model="cell.minCustomerAge">
      </glue-container>
      <glue-container append="'years'"
                      ng-if="column.column === 'maxCustomerAge'">
        <input class="input-days"
               type="number"
               min="0"
               max="100000"
               step="1"
               ng-model="cell.maxCustomerAge">
      </glue-container>
      <cash
        ng-if="column.column === 'exemptionAmount'"
        ng-change="\$ctrl.recalculateAvailableColumns()"
        ng-disabled="\$ctrl.board.amortizationBoard"
        ng-model="cell.exemptionAmount"
        min="0">
      </cash>

      <multiselect ng-if="column.column === 'productStatuses'"
                   items="\$ctrl.allowedFeeStatuses"
                   select-all-option="true"
                   label-property="'label'"
                   value-property="'status'"
                   ng-model="cell.productStatuses"
                   ng-required="true">
      </multiselect>

      <select ng-if="column.column === 'calculationMethod'"
              ng-model="cell.calculationMethod"
              ng-required="\$ctrl.boardType === 'LOAN_BOARD'"
              ng-options="value | prettyEnum for value in \$ctrl.loanCalculationMethods">
      </select>
    </td>

    <td>
      <help
        ng-if="\$ctrl.board.amortizationBoard"
        title="Input disabled. The fee values have to be set per amortization term range in the table below."
      ></help>
      <cash ng-if="\$ctrl.feeType === 'FIXED' && !\$ctrl.board.amortizationBoard"
            ng-model="cell.fixedAmount"
            ng-required="!\$ctrl.board.amortizationBoard"></cash>
      <glue-container
        ng-if="\$ctrl.feeType === 'PERCENTAGE' && !\$ctrl.board.amortizationBoard"
        append-percentage="true">
        <input
          ng-required="!\$ctrl.board.amortizationBoard"
          type="number"
          min="0"
          max="1000"
          step="0.00001"
          ng-model="cell.percentageAmount">
      </glue-container>
    </td>
    <td>
      <button type="button" class="btn btn-danger" ng-click="\$ctrl.removeBoardCell(\$index)">
        Remove
      </button>
    </td>
  </tr>
  </tbody>
  <tfoot>
  <tr>
    <td colspan="{{\$ctrl.getVisibleProductColumns().length + 2}}"></td>
    <td>
      <button type="button" class="btn btn-primary" ng-click="\$ctrl.addNewBoardCell()">
        Add new
      </button>
    </td>
  </tr>
  </tfoot>
</table>

<div class="alert" ng-if="\$ctrl.board.amortizationBoard">
  The fee values below will be applied to amortizations that are due in the term range specified.
</div>
<table class="center-table table table--generate-row-ids"
       ng-if="\$ctrl.board.amortizationBoard">
  <thead>
  <tr>
    <th>No.</th>
    <th ng-repeat="column in \$ctrl.getAmortizationVisibleColumns()">
      {{column.label}}
    </th>
    <th>Fee value</th>
    <th>Action</th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat="cell in \$ctrl.board.amortizationCells">
    <td></td>
    <td ng-repeat="column in \$ctrl.getAmortizationVisibleColumns()">
      <glue-container
        ng-if="column.column === 'minTerm'"
        append="'days'">
        <input class="input-days"
               required
               type="number"
               min="0"
               max="100000"
               step="1"
               ng-model="cell.minTerm">
      </glue-container>
      <glue-container
        ng-if="column.column === 'maxTerm'"
        append="'days'">
        <input class="input-days"
               type="number"
               min="0"
               max="100000"
               step="1"
               ng-change="\$ctrl.recalculateAvailableColumns()"
               ng-model="cell.maxTerm">
      </glue-container>
      <cash
        ng-if="column.column === 'minAmount'"
        ng-model="cell.minAmount"
        ng-required="true"
      ></cash>
      <cash
        ng-if="column.column === 'maxAmount'"
        ng-change="\$ctrl.recalculateAvailableColumns()"
        ng-model="cell.maxAmount"
        min="cell.minAmount"
      ></cash>
      <cash
        ng-if="column.column === 'exemptionAmount'"
        ng-change="\$ctrl.recalculateAvailableColumns()"
        ng-model="cell.exemptionAmount"
        min="0"
      ></cash>
    </td>
    <td>
      <cash ng-if="\$ctrl.feeType === 'FIXED'"
            ng-model="cell.fixedAmount"
            ng-required="true"></cash>
      <glue-container ng-if="\$ctrl.feeType === 'PERCENTAGE'" append-percentage="true">
        <input
          required
          type="number"
          min="0"
          max="1000"
          step="0.00001"
          ng-model="cell.percentageAmount">
      </glue-container>
    </td>
    <td>
      <button type="button" class="btn btn-danger" ng-click="\$ctrl.removeAmortizationBoardCell(\$index)">
        Remove
      </button>
    </td>
  </tr>
  </tbody>
  <tfoot>
  <tr>
    <td colspan="{{\$ctrl.getAmortizationVisibleColumns().length + 2}}"></td>
    <td>
      <button type="button" class="btn btn-primary" ng-click="\$ctrl.addNewAmortizationBoardCell()">
        Add new
      </button>
    </td>
  </tr>
  </tfoot>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/charge/custom-fee-board.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;